export default __webpack_public_path__ + "static/voucher-4863599f4f7e071411c0fcb8dcf73abb.png";